<template>
<div class="container-fluid" >
  
    <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

  <waitingModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal"></waitingModal>
  <supplierDocuments v-if="supplierDocuments.show" @update="setFilteredDocuments" @close="closeModalDocuments" v-bind:props="supplierDocuments"></supplierDocuments>

  <div class="card border-primary">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="fas fa-chart-pie mr-2" aria-hidden="true"></i>SELL OUT FORNITORE/COLLEZIONE </h4>
  </div> 

 <div  class="card-body"> 
  
   <div class="row">
   <div v-if="items.length==0"  class="col"> 

  <div class="" >
  <div class="">

     <i style="color:blue" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong>
    <hr>

    
    
  </div>
  <div class="card-body text-dark">   

  <form name="filter" v-on:submit.prevent="submit()">

    <div class="d-flex align-items-center ml-4 mb-2">
      <supplier-select v-bind:props="supplier" @update="setSupplierId"></supplier-select>
      <collectionSelect class="ml-3" @getDocuments="getDataDocuments()"  v-bind:props="collection" v-bind:binocular="true" @update="setCollectionId"></collectionSelect>                
      
    </div>
    
    
    <span v-if="selectedDocuments.filter"><i :style="{color:'red'}" class="fas fa-filter ml-4 mt-2 mb-2" aria-hidden="true">
      </i>
    FILTRO DOCUMENTI ATTIVO
     </span>

    <div class="d-flex align-items-center ml-4 mb-2">
    <collectionOptionType class="ml-4" v-bind:typeId="collection.typeId" v-bind:option="1"  @update="setCollectionTypeId"></collectionOptionType>  

      <div class="form-check ml-4 mr-4">
        <input class="form-check-input" type="checkbox" id="totalWithReturn" v-model="qtaResa">
        <label class="form-check-label" for="totalWithReturn">
          NON CONSIDERARE I RESI A FORNITORE
        </label>
      </div>

    </div>


    <button v-if="1==0" :disabled="supplier.Id==0 || collection.Id == 0" @click="getDataDocuments()" type="button" class="btn btn-warning mb-4 mt-2">
    <i class="fas fa-folder-open mr-2"></i>
      LISTA DOCUMENTI DI ACQUISTO
      <i v-if="selectedDocuments.filter" :style="{color:'red'}" class="fas fa-filter ml-4" aria-hidden="true"></i>
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </button>  
    
 
    <div class="form-row ml-3">

    <div v-if="1==0" class="col-md-3">  
    <div class="form-group">
      <label for="date_doc"><strong>DATA PRIMO ACQUISTO</strong></label>
      <input @change="setData3()" :disabled="items.length>0" required v-model="data1" type="date" class="form-control" placeholder="" >        
    </div>
    </div>

    <div v-if="1==0" class="col-md-3">  
    <div class="form-group">
      <label for="date_doc"><strong>DATA IMMESSO AL</strong></label>
      <input :disabled="items.length>0" required v-model="data2" type="date" class="form-control" placeholder="" >        
    </div>
    </div>

    <div v-if="1==0" class="col-md-3">  
    <div class="form-group">
      <label for="date_doc"><strong>DATA PRIMA VENDITA </strong></label>
      <input :disabled="items.length>0" required v-model="dataPrimaVendita" type="date" class="form-control" placeholder="" >        
    </div>
    </div>
    
    <div class="col-md-3">  
      <div class="form-group">
        <label for="date_doc"><strong>DATA ULTIMA VENDITA </strong></label>
        <input :disabled="items.length>0" required v-model="dataUltimaVendita" type="date" class="form-control" placeholder="" >   
     
      </div>  
    </div>
    <div class="col-md-3">
      <store-select class="" v-bind:props="store"  @update="setStoreId"></store-select>
    </div>

    </div>


    
    <div class="card border-dark mb-2 ml-3" >

        <div class="card-header">
            <span style="color:black">
              <i class="fas fa-filter mr-2"></i>
              <strong>FILTRO PRODOTTI COLLEZIONE</strong></span>
        </div>
      
      <div class="card-body">


    <div class="form-row">      
    <div class="col-md-3">
      <supplier-brand-list :key="refresh"  v-bind:props="brand" @update="setBrandId"></supplier-brand-list>
    </div>
    
    <div class="col-md-2">
      
      <season-vue-select  @update="setSeasonId" v-bind:props="season"></season-vue-select>
    </div>
  
    <div class="col-md-2">  
      
      <yearVueSelect @update="setYear" v-bind:props="season_year"></yearVueSelect>
    </div>  
    <div class="col-md-2">
  
      <department-select v-bind:props="department" @update="setDepartmentId"></department-select>  
    </div>  
    </div>
  

    <div class="form-row">
    <div class="col-md-3">
      <div class="form-group">
        <line-select :key="refreshLine" v-bind:optionBase="true"  v-bind:Id="lineId" v-bind:supplierId="supplier.Id"  @update="setLineId"></line-select>
        
      </div>
    </div>
        
    <div class="col-md-3">
      <div class="form-group">
        <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <category-select v-bind:props="category"  @update="setCategoryId"></category-select>    
    </div>
    
    </div>

   
    

    </div>

    <div class="col-md-3">
      <customAttributes @update="setAttributes"></customAttributes>  
    </div>
    

    </div>

    </div>



    <span class="ml-3"><strong >TIPO RAGGRUPPAMENTO</strong></span>  
    <div class="ml-3" v-for="(item,index) in grouping" :key="index">  
      <div class="form-check">
        <input @change="setGroup($event)" type="radio" class="form-check-input" :id="'group_by_' + index" :value="index" v-model="group_by">
        <label class="form-check-label"  :for="'group_by_' + index">{{item.group_by}}</label>
      </div>
    </div>
    

     

      
    <div class="card-footer bg-transparent border-info"> 
      <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    <div class="form-check mb-2">
    <input class="form-check-input" type="checkbox" id="soldQty" v-model="qtaVenduta">
    <label class="form-check-label" for="soldQty">
      MOSTRA SOLAMENTE PRODOTTI VENDUTI
    </label>
  </div>   
   <button :disabled="spinner" type="submit"  class="btn btn-primary ">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI RICERCA
      <span v-if="spinner" class="spinner-border spinner-border-sm text-warning ml-3" role="status" aria-hidden="true"></span>
     </button>           
     
  <!--
    <button @click="items=[],row_total=[],component=''" type="button"   class="btn btn-outline-secondary ">
       <i class="fas fa-redo-alt mr-2"></i>     
        RESET
    </button>   
    -->
  </div>
  </form>

  </div>
  </div>
  </div>

<div v-else class="col">
    
  <cancel-btn  @click="refreshData()" v-bind:text="'RITORNA A PARAMETRI RICERCA'" class="mb-1 "></cancel-btn>
    
  <div class="row">
    
    <div v-if="1==0">
    <div  v-if="!onlySelection">
      <span > <strong>Click seleziona riga prodotto</strong></span>
    </div>
    <div v-else>
      <button  :disabled="onlySelection==false" @click="setSelection()" type="button"   class="btn btn-success   mb-1  mr-3">
      <i class="fas fa-eraser mr-2"></i>
        ANNULLA SELEZIONE         
      </button> 
      
    </div>
    </div>


    <div class="custom-control custom-checkbox mr-4 mt-2 ml-4">
      <input v-model="checkHide" type="checkbox" class="custom-control-input" id="customCheck1">
      <label class="custom-control-label" for="customCheck1">NON MOSTRARE VALORE VENDUTO SU PDF.</label>
    </div>  


    <div v-if="1==0" class="custom-control custom-checkbox mr-4 mt-2">
      <input v-model="onlySelection" type="checkbox" class="custom-control-input" id="customCheck2">
      <label class="custom-control-label" for="customCheck2">MOSTRA SOLAMENTE SELEZIONE PRODOTTI</label>
    </div>  

    <div class="row">    
    
    <!-- Example single danger button -->
    <div class="btn-group mb-1">
      <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
        <i class="fas fa-cog mr-2"></i>
        OPZIONI
      </button>
      <div class="dropdown-menu">
        <a @click="pdf()" class="dropdown-item"  href="#">
          <i class="far fa-file-pdf mr-2"></i>
          ESPORTA PRODOTTI E VARIANTI IN FORMATO PDF</a>
        <a  @click="exportProducts()" class="dropdown-item" href="#">
          <i class="fas fa-file-export mr-2"></i>
          ESPORTA PRODOTTI CSV</a>
        <a v-if="1==0" @click="exportVariants()" class="dropdown-item" href="#">
          <i class="fas fa-file-export mr-2"></i>
          ESPORTA VARIANTI CSV</a>

        <div class="dropdown-divider"></div>
          <a @click="setChartData()" class="dropdown-item" href="#">
            <i class="fas fa-chart-pie mr-2"></i>
            VENDITE PER UNITA'</a>
          <a @click="setSalesPerMonthData()" class="dropdown-item" href="#">
             <i class="fas fa-list mr-2"></i>
            VENDITE PER MESE</a>
      </div>
    </div>

    </div>
    
    

    
  </div>

<modalMessageProgressBar  ref="msgModalPBar" v-bind:progress="progress"></modalMessageProgressBar>


  <chartModal v-if="chart.show" @close="chart.show=false" v-bind:data="chart.data"></chartModal>  
  <SalesPerMonth v-if="SalesPerMonth.show" @close="SalesPerMonth.show=false" v-bind:data="SalesPerMonth.data"></SalesPerMonth>

   <product-img v-if="img" @close="img=''" v-bind:img='img'></product-img> 
   <component :key = "componentKey" v-bind:spinner="spinner1" @close="component=''" v-bind:is="component" v-bind:productData="productData" v-bind:cols="cols" v-bind:rows="rows" v-bind:img='img'></component>             
   
   
   <div class="table-wrapper-scroll-y my-custom-scrollbar">

    <table class="table table-bordered table-hover table-sm table-striped mb-0">
    <thead >
      <tr class="table-primary">
                
        <th scope="col"></th>          
        <th class="text-nowrap"  scope="col">ID PROD.</th>
        
        <th  class="text-nowrap" scope="col">SKU</th>
        <th scope="col">STAGIONE</th>
       <!-- <th scope="col">Anno</th>-->
        <th scope="col">REPARTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">LINEA</th>
        <th scope="col">GRUPPO</th>
        <th scope="col">CATEGORIA</th>
        <th class="text-right text-nowrap" scope="col">ACQUISTATO</th>     
        <th class="text-right text-nowrap" scope="col">RESO</th>        
        <th class="text-right text-nowrap" scope="col">VENDUTO</th>
        <th class="text-right text-nowrap" scope="col">SELLTHR UNITA'</th>
        <th class="text-right text-nowrap" scope="col">COSTO UNIT MED. €'</th>
        
        <th class="text-right text-nowrap" scope="col">ACQUISTATO IE (€) </th>
        <th class="text-right text-nowrap" scope="col">VENDUTO IE (€)</th>
        <th class="text-right text-nowrap">COSTO VENDUTO IE (€)</th>
        
        <th class="text-right text-nowrap">SELLTHR COSTO</th>
        <th class="text-right text-nowrap">SELLTHR RETAIL</th>

        <th class="text-right text-nowrap">BEP</th>
        <th class="text-right text-nowrap" scope="col">VENDUTO RETAIL </th>
        <th class="text-right text-nowrap" scope="col">VENDUTO ONLINE </th>
        <th class="text-right text-nowrap" scope="col">VENDUTO ONLINE (€)</th>
        
        <th class="text-right text-nowrap">RETAIL PRICE (€)</th>
        

        <!--<th class="text-right" scope="col">Venduto</th>-->
        
        
        <th class="text-right text-nowrap" scope="col">STOCK</th>
        <th class="text-right text-nowrap" scope="col">VAL. STOCK (€)</th>
       
       <th class="text-right text-nowrap">UTILE (€)</th>
       <th class="text-right text-nowrap">MARGINE</th>
       
      </tr>
    </thead>
    <tbody>
      <tr @click="setDataToExport(index)" @dblclick="openDetail(index)"  :style = "{backgroundColor : rowColor(item), color: item.groupingId == 2  ? 'blue' : 'black',fontSize: item.groupingId == 2 ? '18px':'15px',fontWeight:item.groupingId == 2? 'bold':'normal' }"   data-toggle="tooltip" title="doppio click dettaglio colori " class="pointer" v-for="(item, index) in items" :key="index">
        
        <!--
        <td>
            <input v-if="item.row_type==0" class="pointer" type="checkbox"  v-model.number="item.selected">
        </td>
        -->
        

         <td ><span v-if="item.groupingId==1" :class="{dotRed:item.qtaVenduta == 0}"></span></td> 
         <!--<td><span v-if="item.groupingId==0" >{{index+1}}</span></td> -->
  
        <td >{{item.productId}} </td> 
         <td class="text-nowrap">{{item.sku}} </td> 
        
       

        <td  class="text-nowrap_">{{item.season}} {{item.season_year}}</td>        
    
        <td class="text-nowrap" >{{item.department}}</td>        
        <td class="text-nowrap">{{item.brand}}</td>   
        <td class="text-nowrap">{{item.product_line}}</td>   
        <td class="text-nowrap" >{{item.cat_group}} </td>        
        <td class="text-nowrap">{{item.category}} 
        <small class="text-nowrap" ><p>{{ item.product_description }}</p></small>
        </td>
        <td class="text-right">{{fmt2(item.qtaAcquistata)}} </td>    
        <td class="text-right">
        <p :style="{color:'red',fontWeight:'bold'}" v-if="item.qtaResa>0">{{fmt2(item.qtaResa)}} </p>  
          
          
        </td>        
        <td class="text-right">{{fmt2(item.qtaVenduta)}}</td>
        <td class="text-right">{{item.sellThroughQta}}</td>
        <td v-if="item.groupingId == 1" class="text-right">{{fmt1(item.costoUnit)}}</td>
        <td v-else class="text-right"></td>
        
        
        <td class="text-right">{{fmt1(item.valoreAcquistato)}}</td>
        <td class="text-right">{{fmt1(item.valoreVenduto)}}</td>
        <td class="text-right">{{fmt1(item.costoVenduto)}} </td>        
        
        
        <td class="text-right">
          
          <span class="mr-2" v-if="item.groupingId==1" :class="{dotGreen:parseInt(item.sellThroughCosto) > 100}"></span>
          
          {{item.sellThroughCosto}} </td>

        <td class="text-right">{{item.sellThroughRetail}} </td>
        
        <td class="text-right">{{item.bep}} </td>
        <td class="text-right">{{fmt2(item.qtaVendutaRetail)}}</td>
        <td class="text-right">{{fmt2(item.qtaVendutaMarket)}}</td>
        <td class="text-right">{{fmt1(item.valoreVendutoMarket)}}</td>
        <td class="text-right">{{fmt1(item.retailPrice)}} </td>        
        
        <td class="text-right">{{fmt2(item.stock)}} </td>
        <td class="text-right">{{fmt1(item.valoreStock)}} </td>        
        <td  :style="{color :  fmt1(item.utile).substring(0,1) =='-' ? 'red':'black'}" class="text-right">{{fmt1(item.utile)}} </td>
        <td class="text-right">
        <!--
          <div class="progress">
            <div class="progress-bar bg-success" style="width:100%">{{item.margine}}</div>
          </div>
        -->  
         {{item.margine}}
         
         </td>
        
       
      </tr> 
    </tbody>
    <tfoot>
        <tr  :style="{backgroundColor: item.groupingId == 99 ? '#FFFFE0':'white', color: item.groupingId==99  ? 'blue' : 'black',fontSize: item.groupingId == 9 ? '20px':'15px',fontWeight:item.groupingId == 99 ? 'bold':'normal' }"  data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in row_total" :key="index"> 
        
        <td> </td>       
        <td> </td>
        <td class="text-nowrap">{{ item.sku }} </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        <td class="text-nowrap"> </td>
        
        <td></td>
        <td class="text-right">{{fmt2(item.qtaAcquistata)}} </td>   
        <td class="text-right">{{fmt2(item.qtaResa)}} </td>        
        <td class="text-right">{{fmt2(item.qtaVenduta)}}</td>
        <td class="text-right">{{item.sellThroughQta}}</td>
        <td></td>
        
        <td class="text-right">{{fmt1(item.valoreAcquistato)}}</td>
        <td class="text-right">{{fmt1(item.valoreVenduto)}}</td>
        <td class="text-right">{{fmt1(item.costoVenduto)}} </td>        
        <td class="text-right">{{item.sellThroughCosto}} </td>
        <td class="text-right">{{item.sellThroughRetail}} </td>
        
        <td :style="{color :  item.bep.substring(0,1) == '-' ? 'red':''}"   class="text-right">{{item.bep}} </td>
        <td class="text-right">{{fmt2(item.qtaVendutaRetail)}}</td>
        <td class="text-right">{{fmt2(item.qtaVendutaMarket)}}</td>
        <td class="text-right">{{fmt1(item.valoreVendutoMarket)}}</td>
       
        <td class="text-right"></td>
        
       
       
        <td class="text-right">{{fmt2(item.stock)}} </td>
        <td class="text-right">{{fmt1(item.valoreStock)}} </td>        
        <td :style="{color :  fmt1(item.utile).substring(0,1) =='-' ? 'red':'black'}" class="text-right">{{fmt1(item.utile)}} </td>
        <td class="text-right">{{item.margine}} </td>
       


        
        </tr>   
    </tfoot>    
  </table>

</div>

 

</div>  

</div>

 </div>
 </div>

</div>
</template>
<script>

import api                    from '@/api'
import { mapGetters }         from 'vuex'
import alertBox               from '@/components/common/AlertBox.vue'
import supplierSelect         from '@/components/common/SupplierSelect_1.vue'

import seasonVueSelect        from '@/components/common/SeasonVueSelect_1.vue'

import yearVueSelect          from '@/components/common/YearVueSelect.vue'
import departmentSelect       from '@/components/common/DepartmentVueSelect_1.vue'
import storeSelect            from '@/components/common/StoreSelect_1.vue'
import jsPDF                  from 'jspdf'
//import autoTable              from "jspdf-autotable"

import categorySelect         from '@/components/common/CategorySelect_1.vue'
import productImg             from '@/components/common/ProductImg.vue'
import supplierBrandList      from '@/components/common/SupplierBrandSelect_1.vue'
import cancelBtn              from '@/components/common/CancelBtn.vue'
import supplierDocuments      from '@/components/stat/SupplierCollectionDocuments.vue'
import categoryGrouping       from '@/components/common/CategoryGroupingSelect_1.vue'
import fmt                    from '@/components/mixins/fmt'
import waitingModal           from "@/components/common/WaitingModal.vue"
import lineSelect             from '@/components/common/LineSelect.vue'
import collectionSelect       from '@/components/common/CollectionSelect_1.vue' 
import collectionOptionType   from '@/components/backOffice/CollectionOptionType.vue' 
import chartModal             from '@/components/gchart/gchart3.vue' 
import SalesPerMonth          from '@/components/stat/SalesPerMonth.vue' 
import productModal           from '@/components/stat/ProductModal.vue'
import modalMessage           from '@/components/modalDialog/ModalMessage.vue'   


import foto                   from "@/assets/foto_fake1.jpg";
import modalMessageProgressBar from '@/components/modalDialog/ModalMessageProgressBar.vue'

import customAttributes        from '@/components/product/CompanyAttributes.vue'


export default {
  mixins     : [fmt],
  components: {alertBox,
    supplierSelect,
    departmentSelect,
    productModal,
    categorySelect,
    productImg,
    supplierBrandList,
    cancelBtn,supplierDocuments,
    categoryGrouping,
    storeSelect,
    waitingModal,
    seasonVueSelect,
    yearVueSelect,
    lineSelect,
    collectionSelect,
    collectionOptionType,chartModal,SalesPerMonth,modalMessage,modalMessageProgressBar,customAttributes},
  data() {
    return {

      attributes       : [],
      qtaResa           : 0,
      qtaVenduta        : 0,
      selectedDocuments : {'items':[],'filter':false},
      onlySelection   : false,  
      collection      : 
      {
        Id            : 0,
        isActive      : true,       
        optionBase    : false,
        required      : true,
        typeId        : 3
      },
              
      refreshLine  : 0,
      lineId       : 0,
      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'ELABORAZIONE IN CORSO ...',
        msg2       : '' 

      },
      supplierDocuments : {'show':false},
      checkHide       : false,
      pdf_title       : 
      {        
        season : 'Tutte le stagioni',
        year   : 'Tutti gli anni ',
        group  : '',
        catGroup : '',
        department : 'Tutti i reparti',
        collection : ''
      },
      supplier        : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true

      },
      brand           :
      {
        supplierId    : 0,
        Id            : '%',
        required      : false,
        allBrands     : true

      },  
      store           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false

      },
 
      season          : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : false,
        Ids           : '',
        selection     : []
      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        Ids           : '',
        selection     : []

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : false,
        Ids           : '',
        selection     : ''
       
      },
      category        : 
      {
        Id            : 0,
        isActive      : true,
        
        optionBase    : true,
        required      : false,
        groupId       : 0
       
      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },

       // dataPrimaVendita  : new Date().toISOString().slice(0,10),
      data1             : new Date().toISOString().slice(0,10),
      data2             : new Date().toISOString().slice(0,10),
      dataUltimaVendita : new Date().toISOString().slice(0,10),
      data4             : new Date().toISOString().slice(0,10),

      spinner         : false,
      spinner_pdf     : false,
      spinner_csv     : false,
      spinner1        : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
      grouping        : [],
      group_by        : 0,
      cols            : [],
      rows            : [],
      componentKey    : 0,
      detail          : [],
      isOpen          : [], 
      component       : '', 
      img             : '',
      refresh         : 100,

      chart           : {
      spinner         : false,
      show            : false,
      data            : []
      },
      SalesPerMonth   : {
        spinner       : false,
        show          : false,
        data          : []
      },
      productData     : {},
      progress        : 0,
      
    };
  },

  computed :{
    ...mapGetters(['company']),

    getProgress()
    {
      let p = this.progress
      return p + "%";
    },
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    this.getGrouping()
    this.pdf_title.group = 'Brand'
  },
  methods: {
    setAttributes(items)
    {
      this.attributes = items
      
    },
    rowColor(item) {
      if (item.export === 1) 
      {
        return '#dbfedb'
      }
      if (item.groupingId === 2 && !item.export ) 
      {
        return 'white'  
        //return '#fff7cc'
      }
      return 'white'
    },
  

    async setSalesPerMonthData()
    {
      const products = []
      this.items.forEach(item => {
        if(item.productId)
        {products.push({'productId':item.productId})  }
        
      })
      
      
      const data = await this.getSalesPerMonthData(products,this.data4,this.store.Id)
      this.SalesPerMonth.data = data
      this.SalesPerMonth.show = true
      
      
    },

    async setChartData()
    {
      const products = []
      this.items.forEach(item => {
        if(item.productId)
        {products.push({'productId':item.productId})  }
        
      })
      
      const retailQty = this.row_total[0].venduto_retail_qty
      this.chart.data = []
      this.chart.data.push({'mp':'Retail','totalSold':retailQty})

      const data = await this.getChartData(products,this.data4)
      
      data.forEach(item=>{
        this.chart.data.push({'mp':item.mp,'totalSold':item.totalSold})
      })
      this.chart.show = true
      
      
    },

    async getChartData(products,data) {
            
      const sp      = 'spSalesPerMarket'
      const payload = 
      {
      
        'companyId'    : this.company.Id,
        'data'         : data,
        'products'     : products,
        sp
      }
            
      
       try{
        
          this.$refs.msgModal.show()        
          this.$refs.msgModal.setSpinner(true)  
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
             

             this.$refs.msgModal.close() 
             return res.data.recordsets[0] 


        }catch(err)   
        {
            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err,{},1) 
        }




    },
    async getSalesPerMonthData(products,data,storeId) {
      
      //this.SalesPerMonth.spinner = true      
      const sp      = 'spSalesPerMonth'
      const payload = 
      {
      
        'companyId'    : this.company.Id,
        'data'         : data,
        'products'     : products,
        'storeId'      : storeId,
        sp

      }
            
      
      try{
        
          this.$refs.msgModal.show()        
          this.$refs.msgModal.setSpinner(true)  
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
             

             this.$refs.msgModal.close() 
             return res.data.recordsets[0] 


        }catch(err)   
        {
            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err,{},1) 
        }

    },
    closeModalDocuments()
    {
      
      this.supplierDocuments = {}
    },

    setFilteredDocuments(items)
    {
      this.selectedDocuments.items = items
      this.selectedDocuments.filter = items.length > 0
      
    },
    exportProducts()
    {

      
      const cleanObject = (obj)  =>{
      Object.keys(obj).forEach(k => {
        if (obj[k] === null || obj[k] === undefined) {
          this.$set(obj, k, '')
        }
      })
      return obj
      }

        const  cleanArray = (arr) => {
        return arr.map(row => {
          const cleaned = {}
          Object.keys(row).forEach(k => {
            cleaned[k] =
              row[k] === null || row[k] === undefined
                ? ''
                : row[k]
          })
          return cleaned
        })
      }

    const getData = (items)  =>{

       let data = '' 
       items.forEach(item => {
        
          data += td  + item.productId + td +  sep
          data += td  + item.sku + td +  sep
          data += td  + item.season + td +  sep
          data += td  + item.season_year + td +  sep
          data += td  + item.department + td +  sep
          data += td  + item.brand + td +  sep
          data += td  + item.product_line + td +  sep
          data += td  + item.cat_group + td +  sep
          data += td  + item.category + td +  sep
          data += td  + item.qtaAcquistata + td +  sep
          data += td  + item.qtaResa + td +  sep
          data += td  + item.qtaVenduta + td +  sep
          data += td  + item.sellThroughQta + td +  sep
          data += td  + item.costoUnit + td +  sep
          data += td  + item.valoreAcquistato + td +  sep

          data += td  + item.valoreVenduto + td +  sep
          data += td  + item.costoVenduto + td +  sep
          data += td  + item.sellThroughCosto + td +  sep
          data += td  + item.bep + td +  sep
          data += td  + item.qtaVendutaRetail + td +  sep
          data += td  + item.qtaVendutaMarket + td +  sep
          data += td  + item.valoreVendutoMarket + td +  sep
          data += td  + item.stock + td +  sep
          data += td  + item.valoreStock + td +  sep
          data += td  + this.fmt1(item.utile) + td +  sep
         
          data += td  + item.margine + td +  sep
          data += newLine
        
        
      })
    return data
    }

      const sep = ',' 
      const header =  ['IDPRODOTTO',
                      'SKU',
                      'STAGIONE',
                      'ANNO',
                      'REPARTO',
                      'BRAND',
                      'LINEA',
                      'GRUPPO',
                      'CATEGORIA',
                      'ACQUISTATO',
                      'RESO',
                      'VENDUTO',
                      'SELLTHR-UNIT',
                      'COSTO UNIT MEDIO',
                      '€ ACQUISTATO',
                      '€ VENDUTO',
                      'COSTO VENDUTO',
                      'SELLTHR-COSTO',
                      'BEP',
                      'VENDUTO RETAIL',
                      'VENDUTO ON LINE',
                      'VENDUTO ON LINE €',
                      
                      'STOCK',
                      'VALORE STOCK',
                      'UTILE',
                      'MARGINE']

      //const header =  Object.keys(rs[0])
      const td = '"'
      let index = 0  
      header.forEach(item=>{
        header[index] = td + item + td
        index++
      })
  

    const newLine  = "\x0A"    
    let data = "data:text/csv;charset=utf-8," 
    data += header.join(sep) + newLine
    const items = cleanArray(this.items)
    data += getData(items)  
    const foot = cleanArray(this.row_total)
    data += getData(foot)

      const encodedUri = encodeURI(data);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "exportProducts.csv");
      document.body.appendChild(link); // Required for FF
      link.click(); // This will download the data file named "my_data.csv".

    },
    
    setCollectionId(Id,e)
    {
      this.setFilteredDocuments([])
      this.collection.Id = Id
      this.pdf_title.collection = e.target.options[e.target.options.selectedIndex].text 
      

    },
    setCollectionTypeId(Id)
    {
      
      this.setFilteredDocuments([])
      this.collection.typeId = Id
      
    },
  setData3()
  {
    this.data3 = this.data1
  },    
  setLineId(lineId)
  {
      this.lineId = lineId
      
  },  
  setSelection()
  {
    this.items.forEach(item =>{
      item.export = 0
    })
    this.onlySelection = false
  },    
  setDataToExport(index)
  {
    return
    if(this.items[index].groupingId == 1 )
    {
      const pdf_export = this.items[index].export
      this.items[index].export = pdf_export == 0 ? 1 : 0
    }
    this.onlySelection = false
    this.items.forEach(item =>{
      if(item.export)
      {
        this.onlySelection = true
      }
    })
    
    
  },
  closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },  
  getDataDocuments()
  {
    if(this.supplier.Id == 0 || this.collection.Id == 0)
    {
      return
    }

    this.supplierDocuments = {}
    this.supplierDocuments.show = true
    this.supplierDocuments.supplierId = this.supplier.Id
    this.supplierDocuments.collectionId = this.collection.Id
    this.supplierDocuments.collectionTypeId = this.collection.typeId
    this.supplierDocuments.companyId = this.company.Id
    this.supplierDocuments.selectedDocuments = this.selectedDocuments
    
  },
    refreshData()
    {
      //console.log('Brand',this.brand)
      this.items=[]
      this.row_total=[]

      //this.brand.Id = '%'
      this.refresh++
      this.refreshLine++
    },
    
    setBrandId(brandId)
    {
      if(brandId)
      {
        this.brand.Id = brandId
       
      }
            
    },

    setGroupCategoryId(Id,e)
    {
      
      

      this.catGrouping.Id = Id
      
      this.pdf_title.catGroup = e.target.options[e.target.options.selectedIndex].text  
      if(Id == 0)
      {
        this.pdf_title.catGroup = ''
      }

      

    },
    getProductImg(item)
    {
       this.img = item.img
    },

    async getFlatData()
    {
       this.spinner_csv = true
       const sp          = {'sp' : 'spSellOutSupplierProductVariantsFlat'}
       const data        = {
        'companyId'    : this.company.Id,
        'supplierId'   : this.supplier.Id,
        'data1'        : this.data1, 
        'data2'        : this.data2,
        'data3'        : this.dataUltimaVendita,
        'data4'        : this.data4,
        'seasonId'     : this.season.Ids, 
        'year'         : this.season_year.Ids,
        'departmentId' : this.department.Ids,
        'group_by'     : this.grouping[this.group_by]['group_id'],
        'catGroupId'   : this.catGrouping.Id,
        'categoryId'   : this.category.Id,
        'brand'        : this.brand.Id,
        'storeId'      : this.store.Id,
        'lineId'       : this.lineId,
        'collection'   : this.collection,
        'selectedItems' : this.selectedDocuments.items
      }
     
      const json  = Object.assign(data, sp)
      //this.spinner  = true
      return new  Promise( async (resolve, reject)  =>  {
      await api.post(json).then(res => {
        
            if(res.status==200)
            { 
              
              const data = res.data.recordsets[0] 
              
              resolve(data)
              
            }
            else if (res.status==500)
            {
              
              const data = []
              resolve(data)
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
            }
            else
            {
              
              const data = []
              resolve(data)  
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res
              this.msg.type  = 1
            }

            }).catch(err => 
          {
	            
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1

          }).finally(() => {
              this.spinner_csv = false
          });

      })
          

    },



    async exportVariants()
    {
      const sep = ','
      const td  = '"'
      const header =  ['BARCODE',
                      'BRAND',
                      'LINEA',
                      'IDPRODOTTO',
                      'STAGIONE',
                      'GRUPPO',
                      'CATEGORIA',
                      'SKU',
                      'COLORE',
                      'MISURA',
                      'ACQUISTATO',
                      '€ COSTO UNITARIO',
                      '€ ACQUISTATO',
                      
                      'VENDUTO',
                      '€ VENDUTO',
                      ]

      let index = 0  
      header.forEach(item=>{
        header[index] = td + item + td
        index++
      })
      
      const data = await this.getFlatData()
    
      const lf = '\r\n'

      let csvData = "data:text/csv;charset=utf-8," 
      csvData += header.join(sep) + lf
      let row = ''
      let costPrice = 0
      data.forEach(item => {
        costPrice = 0
        if(item.bought_qty > 0 && item.bought_value > 0)
        {
          //costPrice = Math.ceil(item.bought_value / item.bought_qty)

        }
        
        row += td + item.barcode + td + sep
        row += td + item.brand + td + sep
        row += td + item.line +  td + sep
        row += td + item.productId + td + sep
        row += td + item.season + '_' + item.season_year + td + sep
        row += td + item.cat_grouping + td + sep
        row += td + item.category + td +  sep
        row += td + item.sku + td + sep
        row += td + item.color + td  + sep
        row += td + item.size + td + sep
        row += td + item.bought_qty + td + sep
        row += td + item.costPrice + td + sep
        row += td + item.bought_value + td + sep
        row += td + item.sold_qty + td + sep
        row += td + item.sold_value_novat + td 
        csvData += row + lf
        row = ''


       
      })
      const encodedUri = encodeURI(csvData);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "varianti_sellout_export.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

    },

    
    async pdf()
    { 
      const data = await this.getProductVariants()      
      
      
      
      this.ElaboraPDF(data.prodotti)
            
      
      

    },
    
    setStoreId(storeId,e)
    {
      this.store.Id        = storeId
      this.pdf_title.store = e.target.options[e.target.options.selectedIndex].text     
      if(storeId == 0)
      {
        this.pdf_title.store = ''    
      }
      
    },

    setSupplierId(supplierId,text)
    {  
     
      this.setFilteredDocuments([])
      
      this.supplier.Id = supplierId
      this.pdf_title.supplier = text  
      this.brand.supplierId = supplierId
      this.refresh++
      this.refreshLine++
      
    },  
    setDepartmentId(Ids,text)
    { 

      this.pdf_title.department = text
      this.department.selection = Ids
      let departmentIds = ''
      if (Ids.length > 0)
      {
        departmentIds = Ids.join() 
      }
      this.department.Ids = departmentIds

    },
    /*
    setSeasonId(seasonId,e)
    {           
      this.season.Id        = seasonId
      this.pdf_title.season = e.target.options[e.target.options.selectedIndex].text
    }, 
    */
    /*
    resetData()
  {
    this.data1 = null
    this.data2 = null

  },
  */
    setSeasonId(Ids,text)
    {   
                
      this.pdf_title.season = text  
      this.season.selection = Ids
      let seasonIds = ''
      if (Ids.length > 0)
      {
        seasonIds = Ids.join() 
      }
       
      this.season.Ids = seasonIds
    
    }, 

    setYear(Ids,text)
    {
      
      let season_yearIds = ''      
      this.pdf_title.year   = text
      this.season_year.selection = Ids
           
      if (Ids.length > 0)
      {
        season_yearIds = Ids.join() 
      }
      this.season_year.Ids = season_yearIds
            

    },     
    setCategoryId(categoryId,e)
    {
       

        this.category.Id = categoryId
        this.pdf_title.category = e.target.options[e.target.options.selectedIndex].text                
        if(categoryId==0)
        {
          this.pdf_title.category = 'Tutte le stagioni'                  
        }

        

    },
    setGroup(e) 
    {
      
      //this.pdf_title.group = this.grouping[e.target.value].group_by
        
    },
   
    submit() 
    { 
      let date1 = new Date(this.data1);
      let dateUltimaVendita = new Date(this.dataUltimaVendita);
      let Difference_In_Time = dateUltimaVendita.getTime() - date1.getTime()
      let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      
      if(Difference_In_Days > 365)
      {
        //return
      }

      this.getData()
    },  
    
    async getGrouping()
    {
      this.grouping = []
      var json        = {'sp' : 'spGrouping'}
      
      this.spinner  = true
      await api.post(json).then(res => {
        
            if(res.status==200)
            { 
              this.grouping = res.data.recordsets[0]
              
            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
            }
            else
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res
              this.msg.type  = 1
            }

            }).catch(err => 
          {
	            
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1

          }).finally(() => {
              this.spinner = false
          });


    },

    async openDetail(index)
    {
      
      if(this.items[index]['groupingId'] > 1)
      {
          return
      }
      
      
      this.component     = ''
      
      const data = await this.getModalProductVariants(this.items[index].productId)
      
            let cols = []            
            this.cols = []
            this.rows = []                     
            this.cols.push('Colore')
            this.cols.push('Tipo')           
            this.cols.push('Totale')
             
            cols = data[0]['header'].split('|')

            cols.forEach(item=>{
              this.cols.push(item)
            })
            data.forEach(item=>{
              let sizeList =   this.getSizeList(item.data)
              
              let tmp = {'Colore':item.color,'Tipo':item.tipo,'Totale':item.total}
              let obj = {}
              obj     = Object.assign(obj,tmp)
              obj     = Object.assign(obj,sizeList)
              this.rows.push(obj)

              
            })
            

            this.productData.img   = this.items[index].img
            this.productData.title = this.items[index].productId + ' ' +  this.items[index].category + ' ' + this.items[index].brand + ' '  + this.items[index].sku + ' ' + this.items[index].department + ' ' + this.items[index].season
            this.productData.cols  = this.cols
            this.productData.rows  = this.rows
            
            this.component         = 'productModal'
            this.componentKey++
            this.spinner1 = false


    },

    getSizeList(data)
    { 
      let obj = {}
      if(data)  
      {
      let arr_data = data.split(',')

      arr_data.forEach(item =>{
        let propertyName = ''
        let tmp = {}
        let col  = item.split('|')

        propertyName = col[0]
        
        tmp[propertyName] = col[1]
      
        obj =  Object.assign(obj,tmp);
        

      })
      }
      return obj

    },


    async getData() {
      
      this.row_total = []
      this.items     = []
      this.component = ''  
      
    
      
      const sp = 'spSellOutSupplierCollectionProducts'

      const payload  = {
        'companyId'         : this.company.Id,
        'supplierId'        : this.supplier.Id, 
       // 'dataPrimaVendita'  : this.dataPrimaVendita,              
        'dataUltimaVendita' : this.dataUltimaVendita,
        'seasonIds'         : this.season.Ids, 
        'yearIds'           : this.season_year.Ids,
        'departmentIds'     : this.department.Ids,
        'group_by'          : this.grouping[this.group_by]['group_id'],
        'cat_groupId'       : this.catGrouping.Id,
        'categoryId'        : this.category.Id,
        'brand'             : this.brand.Id,
        'storeId'           : this.store.Id,
        'lineId'            : this.lineId,
        'collection'        : this.collection,        
        'qtaResa'           : this.qtaResa == true ? 0 : 1,
        'qtaVenduta'        : this.qtaVenduta == true ? 1 : 0,
        'attributes'        : this.attributes,  
        sp

      }
      

      console.log(payload)
      try{
        
          this.$refs.msgModal.show()        
          this.$refs.msgModal.setSpinner(true)  
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
                         
             this.$refs.msgModal.close() 
             res.data.recordsets[0].forEach(item =>{

             if(item.groupingId == 1 )
                  {
                    item.export = 0
                  }
              })                          

              this.items     = res.data.recordsets[0].filter(item => item.groupingId == 1 || item.groupingId == 2)                               
              this.row_total = res.data.recordsets[0].filter(item=>item.groupingId==99)

             if(res.data.recordsets[0].length == 0) 
             {
              throw 'DATI INESISTENTI.'
             }

        }catch(err){

            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err,{},1) 
        }
    

    },






    async getModalProductVariants(productId) 
    {
      const products = []
      products.push({'productId' : productId})
      this.component = ''  
      
      this.msg.title = ''
      const sp = {'sp' : 'spProductVariantsCollection_WithReturn'}
      
      
      const body  = {

        'companyId'     : this.company.Id,
        'supplierId'    : this.supplier.Id,
        'data2'         : this.data2,
        'data3'         : this.dataUltimaVendita,
        'data4'         : this.data4,       
        'storeId'       : this.store.Id,        
        'collection'    : this.collection,
        'products'      : products,
        'selectedItems' : this.selectedDocuments.items
        
      }

       

      const json  = Object.assign(body, sp)
  
      this.spinner = true
      this.waitModal.show = true
      return new  Promise( async (resolve, reject)  =>  {
      await api.post(json).then(res => {
         
          if(res.status==200)
            {
             
        
              this.waitModal.sentinel = 1               
              const data = res.data.recordsets[0]
            
              resolve(data)                           
                
            
            if(data.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
                resolve(data)   
              }

            }
            else if (res.status==500)
            {
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              resolve([])   
              
            }
          
          else
          {
            this.waitModal.sentinel = 2
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
            resolve([])       
                        

          }
      }).catch(err=>{
            this.waitModal.sentinel = 3
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
            resolve([])     

      }).finally(() => {
          this.spinner = false
        });
      
      })

    },

    async getProductVariants() 
    {
      
      const products = []
      this.items.forEach((item,index) => 
        {
          if(item.groupingId == 1)
          {            
            products.push({'productId':item.productId,'idx':index})
     
          }
        })
              
      const sp  =    'spSellOutSupplierCollectionVariants'
      const payload  = {

        'companyId'         : this.company.Id,
        'supplierId'        : this.supplier.Id,       
        'dataUltimaVendita' : this.dataUltimaVendita,       
        'storeId'           : this.store.Id,        
        'collection'        : this.collection,
        'products'          : products,
        'qtaResa'           : this.qtaResa == true ? 0 : 1,
        sp
        
        
      }

        try{
        
          this.$refs.msgModal.show()        
          this.$refs.msgModal.setSpinner(true)  
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
             
            

             this.$refs.msgModal.close() 
            
            // console.log('CLOSE MODAL MSG')

             const data = res.data.recordsets[0]
                            
            data[0].prodotti.forEach(item => {
                                            
                const result = {};
                item.quantita.forEach(colore => {
                result[colore.key] = {};

                  colore.value.forEach(tipo => {
                  // value è una stringa → la trasformiamo in array
                    const sizesArray = JSON.parse(`[${tipo.value}]`);
                    result[colore.key][tipo.key] = {};
                    sizesArray.forEach(size => {
                    result[colore.key][tipo.key][size.key] = size.value;
                });
              });
            });

              //console.log(result);
              delete item.quantita
              item.variants = result
             

              })


              return data[0]
                                        

        }
        catch(err)
        {

          this.$refs.msgModal.setSpinner(false)
          this.$refs.msgModal.show(err,{},1) 
          // return []

        }
   

    },



 wait(ms) 
  {
    return new Promise(resolve => {
    setTimeout(() => { resolve('') },ms);
    })
  },






async ElaboraPDF(prodotti) {
  
  this.$refs.msgModalPBar.show('',{title:'CREAZIONE IMMAGINI PDF IN CORSO ...'},6)   
  const doc = new jsPDF({orientation: "landscape" })
  let sum = 0

  const getBodyLastPage = (row,item) => {

  row.push(this.fmt2(item.qtaAcquistata))
  row.push(this.fmt2(item.qtaResa))
  row.push(this.fmt2(item.qtaVenduta))
  row.push(item.sellThroughQta)  
  
  row.push(this.fmt1(item.valoreAcquistato))     
  row.push(!this.checkHide ? this.fmt1(item.valoreVenduto): 0)      
              
    row.push(this.fmt1(item.costoVenduto))
    row.push(item.sellThroughCosto)
    row.push(item.sellThroughRetail)
    row.push(item.bep)
    row.push(this.fmt2(item.qtaVendutaRetail))  
    row.push(this.fmt2(item.qtaVendutaMarket))
    row.push( !this.checkHide ? this.fmt1(item.valoreVendutoMarket) : 0)
    
    row.push(this.fmt2(item.stock))
    row.push(this.fmt1(item.valoreStock))

    //row.push(0)
    //row.push(0)
     

    row.push(item.margine)
    row.push( !this.checkHide ? this.fmt1(item.utile) : 0)
     

    return row

  }  

  
  let r     = 0   
  
  for (let i = 0; i < prodotti.length; i++) 
  {

     let paginaInizioTabella = null;    
     const p = prodotti[i];

    if (i > 0) doc.addPage();

    let y = 15;
    
    /* =====================
       IMMAGINI
    ===================== */
    const imgW = 40;
    const imgH = 50;
    let x      = 10;

    const corsProxy = 'https://45qbufgcqdv6fzpmxo3xraebc40efpwn.lambda-url.eu-central-1.on.aws/?url=';
    //const corsProxy = 'https://proxy-image-170806655659.europe-west1.run.app/?url=';
  
    /*
    for (const url of p.imageUrls.slice(0, 2)) {
      try {
        console.log('URL',url)
        //const base64 = await this.loadImageAsBase64(corsProxy+url);
        doc.addImage(corsProxy+url, 'JPEG', x, y, imgW, imgH);
        x += imgW + 5;
      } catch {}
    }
    */
    const imageUrl = p.imageUrl
    
    /*
    async function imageExists(url) {
    try {
      const res = await fetch(url, { 
        method: "HEAD" 
      });
      return res.ok;
    } catch {
      return false;
    }
    }
    */ 
     try {  
        
        
        r++  
        this.progress = Math.round(r / prodotti.length * 100)
        
        // await wait(0) 
        
        
        
       
        // const base64 = await getBase64FromUrl(imageUrl);
       
          const image = corsProxy +  imageUrl
          doc.addImage(image, 'JPEG', x, y, imgW, imgH);                   
          await new Promise(r => setTimeout(r, 0))


        //const realUrl = corsProxy + imageUrl;
        //doc.addImage(realUrl, 'JPEG', x, y, imgW, imgH);
        /*
        if (await imageExists(realUrl)) {
          doc.addImage(realUrl, 'JPEG', x, y, imgW, imgH);
        } else {
          // console.log('*** FAKE IMAGE ***')
          doc.addImage(foto, 'JPEG', x, y, imgW, imgH);
        }
        */

        x += imgW + 5;
 
      } catch {
        
      }

        
     /* =====================
       ANAGRAFICA
    ===================== */

    x = 60
    y += 7
    let col = 60
    const step = 5.5
    doc.setFont("helvetica",'normal')
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`ID PRODOTTO`, x, y)

    doc.setTextColor(0, 0, 255);
    doc.setFontSize(14);
    doc.text(`${p.productId}`, x + col , y); y += step

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.text(`SKU`, x, y)

    doc.setTextColor(0, 0, 255);
    doc.setFontSize(14);
    doc.text(`${p.sku}`, x + col, y); y += step

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.text(`BRAND`, x, y)
    
    doc.setTextColor(0, 0, 255);
    doc.setFontSize(14);
    doc.text(`${p.brand}`, x + col, y); y += step

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.text(`REPARTO`, x, y); 

    doc.setTextColor(0, 0, 255);
    doc.setFontSize(14);
    doc.text(`${p.department}`, x + col, y); y += step;

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.text(`STAGIONE`, x, y); 

    doc.setTextColor(0, 0, 255);
    doc.setFontSize(14);
    doc.text(`${p.season}`, x + col, y); y += step;

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10); 
    doc.text(`GRUPPO/CATEGORIA`, x, y)

    doc.setTextColor(0, 0, 255);
    doc.setFontSize(14);
    doc.text(`${p.cat_group}  ${p.category}`, x + col, y); y += step;

    
    if(p.product_description)  
    {
      doc.setTextColor(0, 0, 0);  
      doc.setFontSize(10);
      doc.text(`DESCRIZIONE`, x, y)

      doc.setTextColor(0, 0, 255);
      doc.setFontSize(14);
      doc.text(`${p.product_description.substring(0,30)}`, x + col, y); y += step;
    
    }  
    if(p.product_line)
    {
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(10);      
      doc.text(`LINEA`, x, y)

      doc.setTextColor(0, 0, 255);  
      doc.setFontSize(14);
      doc.text(`${p.product_line.substring(0,30)}`, x + col, y); y += step;
    
    }  
    if(p.product_material)
    {
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(10);      
      doc.text(`MATERIALE`, x, y)
      
      doc.setTextColor(0, 0, 255);  
      doc.setFontSize(14);
      doc.text(`${p.product_material.substring(0,30)}`, x + col, y); y += step;
    
    }  
    y = 70

    
      
    
      
      const venditeMarket = (p,y) => {

        const head   = [['MARKET','VENDUTO UNITA','VENDUTO €']];  
        const body   = [];  
        let row      = []

             if(p.VenditeMarket) 
             {
              p.VenditeMarket.forEach(item => {
                row = []
                row.push(item.market)  
                row.push(item.qtaVendutaMarket)  
                row.push(this.fmt1(item.valoreVendutoMarket))  
                body.push(row)  
              })
              
             }

          doc.autoTable({
            startY: y,
            head,
            body,
            theme: 'grid',  
              headStyles: {
              fontSize  : 6,
              fillColor : [192,192,192],   // grey
              textColor : [0,0,0],     // nero
              fontStyle : 'bold',
              lineWidth : 0.8
              }, 
            margin: { left: 10, right: 10 },

          })   

      }

      
      
      const productTable = (product,y) => {


        const getBody = (row,item) => {

                row.push(this.fmt2(item.qtaAcquistata))
                row.push(this.fmt2(item.qtaResa))
                row.push(this.fmt2(item.qtaVenduta))
                row.push(item.sellThroughQta)
                row.push(this.fmt1(item.costoUnit))                  
                row.push(this.fmt1(item.valoreAcquistato))     
                row.push(!this.checkHide ? this.fmt1(item.valoreVenduto): 0)      
                row.push(this.fmt1(item.costoVenduto))
                row.push(item.sellThroughCosto)
                row.push(item.sellThroughRetail)
                row.push(item.bep)

                if(item.VenditeMarket)
                {
                  row.push(this.fmt2(item.qtaVendutaRetail))  
                }
                                   
                row.push(this.fmt2(item.stock))
                row.push(this.fmt1(item.valoreStock))

                //row.push(0)
                //row.push(0)

                row.push(item.margine)
                row.push( !this.checkHide ? this.fmt1(item.utile) : 0)
                row.push(this.fmt1(item.retailPrice))  
                  
                


    return row

}  




    
            const head   = [['ACQUISTATO','RESO','VENDUTO','SELLTHR-UNITA','COSTO UNIT €', 'ACQUISTATO €','VENDUTO €','COSTO VENDUTO','SELLTHR-COSTO','SELLTHR-RETAIL','BEP',
            'VENDUTO RETAIL','VENDUTO ONLINE','VAL_VENDUTO ONLINE €',
            'STOCK','VAL_STOCK','MARGINE','UTILE','RETAIL PRICE']];  
            const indexVendutoRetail = head[0].indexOf('VENDUTO RETAIL');

            if(product.VenditeMarket)
            {

                  //const indexVendutoRetail = head[0].indexOf('VENDUTO RETAIL');
                  // tiene la prima e rimuove le due successive
                  head[0].splice(indexVendutoRetail, 3, 'VENDUTO RETAIL');

            }
            else
            {
                  //const indexVendutoRetail = head[0].indexOf('VENDUTO RETAIL');
                  // tiene la prima e rimuove le due successive
                  head[0].splice(indexVendutoRetail, 3);

            }

            
            const body   = [];            
            const prodotto = this.items.find(p => p.productId === product.productId)
            const item =  Object.assign({}, prodotto, product);
                          
            const row = getBody([],item)                 
            body.push(row)
              
           const columnStyles = { 0: { halign: 'left',cellWidth: 'auto' } }; 
            for (let i = 1; i < head[0].length; i++) { 
                columnStyles[i] = { halign: 'right',cellWidth: 'auto', whiteSpace: 'nowrap' }

          }

                 
              
    
    doc.autoTable({
      startY: y,
      head,
      body,
      theme: 'grid',   
      columnStyles,
      willDrawCell: function (data) 
      { 
        const lastRowIndex = data.table.body.length - 1
        // Se siamo sull'ultima riga 
        if (data.row.index === lastRowIndex) 
        { 

          // doc.setFillColor(230, 230, 230)
          doc.rect( data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F' ); 
        } 
      } ,
      
      styles: {
        fontSize: 8,
        halign: 'center',
        whiteSpace: 'nowrap'
        },
    
      headStyles: {
        fontSize  : 6,
        fillColor : [192,192,192],   // verde
        textColor : [0,0,0],     // nero
        fontStyle : 'bold',
        lineWidth : 0.8
      },
      
      didParseCell: function (data) {
    
      if (data.section === 'head' && data.column.index < 1) { 
        //data.cell.styles.fillColor = [129, 133, 137]; 
      }
      if (data.section === 'head' ) { 
        //data.cell.styles.overflow = 'hidden'; 
        //data.cell.styles.cellWidth = 'auto'; 
        
      }

    // SOLO body
    if (data.section !== 'body') return;

      if (data.column.index == 0) { 
        //data.cell.styles.overflow = 'hidden'; 
        //data.cell.styles.cellWidth = 'auto'; 
      }


      const lastRowIndex = data.table.body.length - 1; 
      if (data.row.index === lastRowIndex && data.section === 'body') 
      { 
        data.cell.styles.fontSize =   10 ; 
        data.cell.styles.fontStyle = 'bold'; 

      }
    

      
      if (data.section === 'body') 
      { const colIndex = data.column.index; const value = data.cell.raw; 
        // Colonna 2 (indice 2) e valore zero 
        if (colIndex === 2 && (value === 0 || value === "0")) 
        { data.cell.styles.textColor = [255, 0, 0]; 
          //data.cell.styles.fontStyle = 'bold'; // opzionale 
        } 
      }


    },

      margin: { left: 10, right: 10 },

    });

    } 

    productTable(p,y)    
    y += 20

     
     if(p.VenditeMarket)
      {
        venditeMarket(p,y)  
        const finalY = doc.lastAutoTable.finalY
        y = finalY + 5
      }

    /* =====================
       TABELLA MISURE x COLORI
    ===================== */

    const misure = p.misure.split(",")
    const head   = [['Colore', 'Tipo','Totale', ...misure]];
    const tipi   = ['ACQUISTATO', 'RESO', 'VENDUTO','STOCK'];
    const body   = [];
    const colori = p.colori.split(",")
    colori.forEach((colore) => {
        tipi.forEach((tipo, index) =>
        {
          const row = [];
          // Scrivo il colore solo sulla prima riga
          row.push(index === 0 ? colore : '');

          // Tipo riga
          row.push(tipo);
          row.push(0)
          

          let total = 0  
          // Valori per ogni misura
          misure.forEach((m) => {
          
          if (
              p.variants &&
              p.variants[colore] &&
              p.variants[colore][tipo] &&
              p.variants[colore][tipo][m] !== undefined
              ) 
              {
                total += p.variants[colore][tipo][m]                
                row.push(p.variants[colore][tipo][m]);
          } else {
                row.push(0);
          }
      });
     

      
      for (let j = 0; j < row.length; j++) 
      {
        const tipo = row[1]
        
        if(tipo == 'RESO' || tipo == 'VENDUTO')
        {
          sum = 0
          for (let t = 3; t < row.length; t++) 
          {
            sum = sum + row[t]
           }
           
        }
      }

      row[2]= total
      if(row[1] === 'ACQUISTATO')
      {
        
        body.push(row);        
      }

      if(row[1] === 'VENDUTO' && sum > 0)
      {
        
        body.push(row);        
        //sum = 0
      }


      if(row[1] === 'RESO' && sum > 0)
      {
        
        body.push(row);      
        //sum = 0
      }

      if(row[1] === 'STOCK' )
      {
        
        body.push(row);      
        //sum = 0
      }
      
      
        

  });
});

    
    
    doc.autoTable({
      startY: y,
      head,
      body,
      theme: 'grid',   

      didDrawPage: function (data) {
      const pageCorrente = doc.internal.getCurrentPageInfo().pageNumber;

      if (paginaInizioTabella === null) {
        // Salva la prima pagina della tabella di questo prodotto
        paginaInizioTabella = pageCorrente;
        return; // niente messaggio sulla prima pagina
      }

      if (pageCorrente > paginaInizioTabella) {
        // Solo sulle pagine successive della stessa tabella
        doc.setFontSize(9);
        doc.setTextColor(120);
        doc.text(
          'Continua dalla pagina precedente',
          data.settings.margin.left,
          12
        );
      }

    

    },
  
      styles: {
        fontSize: 8,
        halign: 'center'
        },
    
      headStyles: {
        fontSize  : 10,
        fillColor : [0, 153, 0],   // verde
        textColor : [255, 255, 255],     // nero
        fontStyle : 'bold',
        lineWidth : 0.8
      },
      columnStyles: {
        0: { halign: 'left', cellWidth: 30 }
      },

      didParseCell: function (data) {
      
        

      if (data.section === 'head' && data.column.index < 3) { 
        data.cell.styles.fillColor = [129, 133, 137]; 
      }


    // SOLO body
    if (data.section !== 'body') return;

      if (data.column.index == 0) { 
        data.cell.styles.overflow = 'hidden'; 
        data.cell.styles.cellWidth = 'auto'; 
        data.cell.styles.fontStyle = 'bold';
      }


    const tipo = data.row.raw[1]; // colonna "Tipo"
    const valore = data.cell.raw;

    /* =====================
       COLORI PER TIPO RIGA
    ===================== */
    if (tipo === 'ACQUISTATO') {
      data.cell.styles.fillColor = [220, 235, 255]; // azzurro
    }

    if (tipo === 'RESO') {
      //data.cell.styles.fillColor = [255, 230, 200]; // arancione
    }

    if (tipo === 'VENDUTO') {
      //data.cell.styles.fillColor = [220, 245, 220]; // verde
    }

    /* =====================
       EVIDENZIA ZERO STOCK
    ===================== */
    if (
      data.column.index > 1 &&     // solo celle quantità
      Number(valore) > 0
    ) {
       //data.cell.styles.fillColor = [255, 255, 255]; // rosso chiaro
      //data.cell.styles.textColor = [150, 0, 0];     // rosso scuro
      data.cell.styles.fontStyle = 'bold';
    }
    },

      margin: { left: 10, right: 10 },


    });


  }

     this.progress = 0
  
      const header = (page) =>{

            // const data = new Date(this.data3).toLocaleDateString()
            
            doc.setPage(page)

            doc.setDrawColor(0)
            doc.setFillColor(0,0,153)
            doc.roundedRect(3, 3, 292, 5,1,1,'FD')      


            doc.setFontSize(10)
            doc.setFont("helvetica",'bold')
            doc.setTextColor(255, 255, 255)  
            doc.text('SELL OUT ' + this.pdf_title.supplier  + ' COLLEZIONE ' + this.pdf_title.collection   , 150, 6.5,null,null,'center');
            doc.setTextColor(0, 0, 0)  
            
            doc.setFontSize(7)
            doc.setFont("helvetica",'italic')
            doc.text( 'Tipo raggruppamento ' + this.grouping[this.group_by].group_by,  150, 10.5,null,null,'right');
            doc.setFont("helvetica",'normal')


      }

      const addLastPage = () =>{

            doc.addPage()
            const head   = [['GRUPPO', 'ACQUISTATO','RESO','VENDUTO','SELLTHR_UNIT','ACQUISTATO €','VENDUTO €','COSTO VENDUTO','SELLTHR-COSTO','SELLTHR-RETAIL','BEP','VENDUTO RETAIL','VENDUTO ONLINE','VAL_VENDUTO ONLINE €', 'STOCK','VAL_STOCK','MARGINE','UTILE']];  
            const body   = [];
            this.items.forEach(item=>{              
            
            if(item.groupingId == 2)
            {
                           
              const row = []
              
              row.push(
              [item.brand, item.cat_group, item.category,item.product_line]
              .filter(v => v && v.trim() !== "")
              .join(" ")
              );
           
              body.push(getBodyLastPage(row,item))
              
            }
          })
          this.row_total.forEach(item => {
            const row = []
              
              row.push('TOTALE')
              body.push(getBodyLastPage(row,item))

          })
          


     const columnStyles = { 0: { halign: 'left',cellWidth: 'auto' } }; 
            for (let i = 1; i < head[0].length; i++) { 
                columnStyles[i] = { halign: 'right',cellWidth: 'auto' }

          }

    let y = 15      
    doc.autoTable({
      startY: y,
      head,
      body,
      theme: 'grid',   
      columnStyles,
      willDrawCell: function (data) 
      { 
        const lastRowIndex = data.table.body.length - 1
        // Se siamo sull'ultima riga 
        if (data.row.index === lastRowIndex) 
        { 
          
          doc.setFillColor(230, 230, 230)
          doc.rect( data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F' ); 
        } 
      } ,
      
      styles: {
        fontSize: 8,
        halign: 'center'
        },
    
      headStyles: {
        fontSize  : 6,
        fillColor : [0,128,128],   // verde
        textColor : [255, 255, 255],     // nero
        // fontStyle : 'bold',
        lineWidth : 0.8
      },
      
      didParseCell: function (data) {
    
        if (data.section === 'head' && data.column.index < 1) 
        { 
          data.cell.styles.fillColor = [129, 133, 137]; 
        }
        if (data.section === 'head' ) 
        { 
          //data.cell.styles.overflow = 'hidden'; 
          data.cell.styles.cellWidth = 'auto'; 
          
        }

    // SOLO body
    if (data.section !== 'body') return;

      if (data.column.index == 0) { 
        //data.cell.styles.overflow = 'hidden'; 
        data.cell.styles.cellWidth = 'auto'; 
      }


      const lastRowIndex = data.table.body.length - 1; 
      if (data.row.index === lastRowIndex && data.section === 'body') 
      { 
        data.cell.styles.fontSize =   10 ;
        data.cell.styles.fontStyle = 'bold'; }

    
    

    },

      margin: { left: 10, right: 10 },


    });

    
}
            



addLastPage() 

const totalPages = doc.internal.getNumberOfPages();
doc.setFont('helvetica', 'normal')

for (let i = 1; i <= totalPages; i++) {

  doc.setPage(i);
  header(i)
  doc.setFontSize(9);
  doc.text(
    `Pagina ${i}/${totalPages}`,
    doc.internal.pageSize.width - 30,
    doc.internal.pageSize.height - 10
  );
}


  this.$refs.msgModalPBar.close()   
  window.open(URL.createObjectURL(doc.output("blob")))
  
},









  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position   : relative;
height     : 800px;
overflow   : auto;
}



.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
   /* background   : hwb(45 4% 9%); 
    color        : black;   
   */ 
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

 /* tutti gli header */
.table thead th {
 
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2 !important;

}


 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 22px;
    background   : rgb(222, 215, 215);
    font-weight  : bold;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

.pointer:hover
{
  background-color : blue !important  ;
  color            : white !important;
  cursor           : pointer;
}


.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.custom-control-label{
  cursor:pointer;
  color:blue;
  font-weight: bold;
}
.dotRed
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color:red
}

.dotGreen
{
  height: 15px;
  width: 15px;
  
  border-radius: 50%;
  display: inline-block;
  background-color:darkgreen
}



.table {
  border-collapse: separate;
}


</style>